import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const fetchUser = createAction(`${SLICE_NAME}/fetchUser`);
